import { useEffect, useState } from 'react'
import { isNative, apiFetch, assetUrl } from '../lib/config'

// 1×1 transparentes GIF als Platzhalter, solange das Blob im nativen Build lädt.
const TRANSPARENT = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='

type Props = React.ImgHTMLAttributes<HTMLImageElement> & { src: string | null | undefined }

/**
 * Bild vom (auth-geschützten) API-Proxy (Immich/Tandoor). Im nativen Capacitor-Build
 * lädt ein normales <img> cross-origin OHNE Cookie/Bearer → 401. Deshalb hier per
 * `apiFetch` (Bearer-Header) → Blob-URL. Im Web bleibt es ein normales <img>
 * (same-origin Cookie), inkl. HTTP-Caching. `src` = relativer `/api/…`-Pfad.
 */
export function AuthImage({ src, ...img }: Props): React.JSX.Element | null {
  const [objUrl, setObjUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!isNative || !src) {
      setObjUrl(null)
      return
    }
    let cancelled = false
    let created: string | null = null
    apiFetch(src)
      .then((r) => (r.ok ? r.blob() : null))
      .then((b) => {
        if (b && !cancelled) {
          created = URL.createObjectURL(b)
          setObjUrl(created)
        }
      })
      .catch(() => {})
    return () => {
      cancelled = true
      if (created) URL.revokeObjectURL(created)
    }
  }, [src])

  if (!src) return null
  if (!isNative) return <img src={assetUrl(src)} {...img} />
  return <img src={objUrl ?? TRANSPARENT} {...img} />
}
